export default {
      id: "ic_games_search-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_games_search-usage",
      toString: function () {
        return this.url;
      }
    }